import { useCallback, useContext, useState } from 'react';

import { Button } from 'antd';

import { FormGroupContext } from '@/components/FormGroup';
import Info from '@/components/icons/Info';
import ImportantInformation from '@/components/modals/ImportantInformation';
import TestError from '@/components/TestError';
import BillingModel from '@/components/wizard/BillingModel';
import Categories from '@/components/wizard/Categories';
import Files from '@/components/wizard/Files';
import FiscalTerm from '@/components/wizard/FiscalTerm';
import Image from '@/components/wizard/Image';
import ProducerAddress from '@/components/wizard/ProducerAddress';
import ProducerCellPhone from '@/components/wizard/ProducerCellPhone';
import ProducerDocument from '@/components/wizard/ProducerDocument';
import ProductDescription from '@/components/wizard/ProductDescription';
import ProductEmail from '@/components/wizard/ProductEmail';
import ProductPaymentMethods from '@/components/wizard/ProductPaymentMethods';
import ProductPrice from '@/components/wizard/ProductPrice';
import ProductTitle from '@/components/wizard/ProductTitle';
import UpgradeSales from '@/components/wizard/UpgradeSales';
import UseTerm from '@/components/wizard/UseTerm';
import { validateFields } from '@/lib/validation';
import useStepStore from '@/stores/steps';

export default function Blululup() {
  const { emit } = useContext(FormGroupContext);
  const nextStep = useStepStore(({ nextStep }) => nextStep);
  const [openInfo, setOpenInfo] = useState(false);

  const submit = useCallback(async () => {
    const results = await emit({ type: 'validate' });
    nextStep({ validate: () => validateFields(results) });
  }, [emit, nextStep]);

  return (
    <div className='flex w-[600px] flex-col gap-4'>
      <TestError />

      <ProducerAddress />
      <a id='modal-info' onClick={() => setOpenInfo(!openInfo)}>
        <Info />
      </a>

      <ImportantInformation openInfo={openInfo} setOpenInfo={setOpenInfo} />

      <ProductPrice />
      <ProductTitle />
      <ProductDescription />
      <UpgradeSales />
      <ProductPaymentMethods />
      <Files />
      <Image />
      <ProductEmail />
      <Categories />
      <FiscalTerm />
      <ProducerDocument />
      <ProducerCellPhone />
      <UseTerm />
      <BillingModel />

      <div className='flex flex-row justify-end'>
        <Button type='primary' className='mt-4' id='submit' onClick={submit}>
          Proxima Step
        </Button>
      </div>
    </div>
  );
}
